export const getOrganizations = (state, props) => { return (props.organizations || state.admin.organizations || []) };

export const getOrganization = (state, props) => {
  return (
    (state.admin.organization) ||
    (props.location.state && props.location.state.organization) ||
    (state.admin.organizations && state.admin.organizations.filter((org) => {return org.id == props.match.params.organizationId})[0])
  )
};
